module.exports = require('webrtc-adapter')
